import React from 'react';
import { motion } from 'framer-motion';
import { HousingAssociation } from '../data/housingAssociations';
import { ScoreBreakdown } from './ScoreBreakdown';
import { ArrowUpRightIcon } from 'lucide-react';
interface RankingCardProps {
  association: HousingAssociation;
  rank: number;
  index: number;
}
export function RankingCard({
  association,
  rank,
  index
}: RankingCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-1">
      <div className="flex gap-8" data-id="element-2">
        {/* Rank Number */}
        <div className="flex-shrink-0" data-id="element-3">
          <div className="text-7xl font-bold text-blue-600 leading-none" data-id="element-4">
            {rank}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0 flex gap-6" data-id="element-5">
          {/* Left: Text Content */}
          <div className="flex-1 min-w-0" data-id="element-6">
            {/* Header */}
            <div className="flex items-start justify-between gap-4 mb-3" data-id="element-7">
              <div className="flex-1 min-w-0" data-id="element-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-1 flex items-center gap-2" data-id="element-9">
                  {association.name}
                  <ArrowUpRightIcon className="w-5 h-5 text-gray-400" data-id="element-10" />
                </h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-11">
                  {association.location} • Est. {association.yearEstablished}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2" data-id="element-12">
                  {association.tags.map(tag => <span key={tag} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100" data-id="element-13">
                      {tag}
                    </span>)}
                </div>
              </div>
              <div className="flex-shrink-0 text-right" data-id="element-14">
                <div className="text-5xl font-bold text-gray-900" data-id="element-15">
                  {association.overallScore}
                </div>
                <div className="text-sm text-gray-500 mt-1" data-id="element-16">Overall Score</div>
              </div>
            </div>

            {/* Score Breakdown */}
            <div className="mb-6 max-w-xs" data-id="element-17">
              <ScoreBreakdown residentScore={association.residentExperienceScore} financialScore={association.financialPerformanceScore} data-id="element-18" />
            </div>

            {/* Metrics */}
            <div className="flex gap-8 text-sm" data-id="element-19">
              <div data-id="element-20">
                <span className="text-gray-500" data-id="element-21">Units Managed:</span>{' '}
                <span className="font-semibold text-gray-900" data-id="element-22">
                  {association.unitsManaged.toLocaleString()}
                </span>
              </div>
              <div data-id="element-23">
                <span className="text-gray-500" data-id="element-24">Tenant Satisfaction:</span>{' '}
                <span className="font-semibold text-gray-900" data-id="element-25">
                  {association.tenantSatisfaction}%
                </span>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="flex-shrink-0 w-80" data-id="element-26">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-gray-100" data-id="element-27">
              <img src={association.imageUrl} alt={`${association.name} housing`} className="w-full h-full object-cover" data-id="element-28" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}